import { Route, Routes } from "react-router-dom"
import "./App.css"
import Login from "./component/Login";
import Dashboard from "./component/Users/Dashboard";
import CreateTender from "./component/Users/CreateTender";
import SingleTender from "./component/Users/SingleTender";
import VendorSignUp from "./component/Vendor/VendorSignUp";
import VendorDetails from "./component/Vendor/VendorDetails";
import VendorDashboard from "./component/Vendor/VendorDashboard";
import UserDashboard from "./component/Users/UserDashboard";
import SuperadminDashboard from "./component/Superadmin/SuperadminDashboard";
import AllOrgs from "./component/Superadmin/AllOrgs";
import CreateOrg from "./component/Superadmin/CreateOrg";
import ForgotPassword from "./component/ForgotPassword";
import AdminDashboard from "./component/Admin/AdminDashboard";
import AllOrgsUsers from "./component/Admin/AllOrgUsers";
import CreateUser from "./component/Admin/CreateUser";
import OrgDetails from "./component/Admin/OrgDetails";
import EditOrg from "./component/Superadmin/EditOrg";
import EditAdmin from "./component/Superadmin/EditAdmin";
import MyTenders from "./component/Vendor/MyTenders";
import MyBuyers from "./component/Vendor/MyBuyers";
import QualificationDetails from "./component/Vendor/QualificationDetails/QualificationDetails";
import EditTender from "./component/Users/EditTender";
import EditTenderApprover from "./component/Users/EditTenderApprover";
import SingleVendor from "./component/Users/SingleVendor";
import BriefTender from "./component/Users/BriefTender";
import TenderByBuyer from "./component/Vendor/TenderByBuyer";
import BidSubmission from "./component/Vendor/BidSubmission/BidSubmission";
import DecryptBid from "./component/Users/CXO/DecryptBid";
import ReviewBids from "./component/Users/TechnicalHead/ReviewBids";
import ReviewBidsValue from "./component/Users/PurchaseHead/ReviewBidsValue";
import ViewAllBids from "./component/Users/PurchaseHead/ViewAllBids";
import ViewBids from "./component/Users/TechnicalHead/ViewBids";
import SignUpBuyer from "./component/SignUpBuyer";
import RebidSubmission from "./component/Vendor/RebidSubmission/RebidSubmission";
import ViewTenderDetails from "./component/Vendor/ViewTenderDetails";
import ViewQualification from "./component/Vendor/ViewQualification";
import ViewEMD from "./component/Vendor/ViewEMD";
import ViewVendorBids from "./component/Vendor/ViewVendorBids";
import ViewQueries from "./component/Vendor/ViewQueries";
import AskQuery from "./component/Vendor/AskQuery";
import DashboardPending from "./component/Users/DashboardPending";
import ProtectedRoute from "./middleware/ProtectedRoute";
import BankDetail from "./component/Superadmin/BankDetail";
import TenderPurchases from "./component/Superadmin/TenderPurchases";
import VendorQualificationTab from "./component/Users/BriefTender/VendorQualificationTab";
import { useEffect } from "react";
import Units from "./component/Superadmin/Units";

function App() {
  useEffect(() => {
    const wheelHandler = (e) => {
      if (document.activeElement.matches('input[type=number]')) {
        e.preventDefault();
      }
    };

    const keyHandler = (e) => {
      if (
        document.activeElement.matches('input[type=number]') &&
        (e.key === "ArrowUp" || e.key === "ArrowDown")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", wheelHandler, { passive: false });
    window.addEventListener("keydown", keyHandler);

    return () => {
      window.removeEventListener("wheel", wheelHandler);
      window.removeEventListener("keydown", keyHandler);
    };
  }, []);
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/user-onboarding" element={<ForgotPassword />} />
        <Route path="/signup-buyer" element={<SignUpBuyer />} />

        <Route element={<ProtectedRoute allowedRoles={["BUYER", "PURCHASE_HEAD", "TECHNICAL_HEAD", "FINANCE_HEAD", 'COO', 'CFO', 'CEO', 'CMD']} />}>
          <Route path="/dashboard" element={<UserDashboard />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/pending-actions" element={<DashboardPending />} />
            <Route path="/dashboard/create-tender" element={<CreateTender />} />
            <Route path="/dashboard/create-tender/draft/:tenderId" element={<CreateTender />} />
            <Route path="/dashboard/:tenderId" element={<BriefTender />} />
            <Route path="/dashboard/:tenderId/vendor/:vtqId" element={<SingleVendor />} />
            <Route path="/dashboard/tender/:tenderId" element={<SingleTender />} />
            <Route path="/dashboard/edit-tender/:tenderId" element={<EditTender />} />
            <Route path="/dashboard/edit-approver/:tenderId" element={<EditTenderApprover />} />
            <Route path="/dashboard/vendor/:vtqId" element={<SingleVendor />} />
            <Route path="/dashboard/bid-opening/:tenderId" element={<DecryptBid />} />
            <Route path="/dashboard/view-bid/:tenderId" element={<ViewBids />} />
            <Route path="/dashboard/review-bid/:tenderId" element={<ReviewBids />} />
            <Route path="/dashboard/view-bid-data/:tenderId" element={<ViewAllBids />} />
            <Route path="/dashboard/review-bid-data/:tenderId" element={<ReviewBidsValue />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["SUPERADMIN"]} />}>
          <Route path="/superadmin-dashboard" element={<SuperadminDashboard />}>
            <Route path="/superadmin-dashboard" element={<AllOrgs />} />
            <Route path="/superadmin-dashboard/purchase" element={<TenderPurchases />} />
            <Route path="/superadmin-dashboard/:tenderId" element={<VendorQualificationTab />} />
            <Route path="/superadmin-dashboard/create-org" element={<CreateOrg />} />
            <Route path="/superadmin-dashboard/units" element={<Units />} />
            <Route path="/superadmin-dashboard/bank-detail" element={<BankDetail />} />
            <Route path="/superadmin-dashboard/org/:orgId" element={<EditOrg />} />
            <Route path="/superadmin-dashboard/:orgId/admin" element={<EditAdmin />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminDashboard />}>
            <Route path="/admin" element={<AllOrgsUsers />} />
            <Route path="/admin/org-details" element={<OrgDetails />} />
            <Route path="/admin/create-user" element={<CreateUser />} />
            <Route path="/admin/:orgUserId" element={<CreateUser />} />
          </Route>
        </Route>
        
        <Route path="/signup" element={<VendorSignUp />} />
        <Route element={<ProtectedRoute allowedRoles={["VENDOR"]} />}>
          <Route path="/vendor/details" element={<VendorDetails />} />
          <Route path="/vendor/dashboard" element={<VendorDashboard />}>
            <Route path="/vendor/dashboard" element={<MyTenders />} />
            <Route path="/vendor/dashboard/buyers" element={<MyBuyers />} />
            <Route path="/vendor/dashboard/buyers/:orgId" element={<TenderByBuyer />} />
            <Route path="/vendor/dashboard/:tenderId" element={<ViewTenderDetails />} />
            <Route path="/vendor/dashboard/:tenderId/qualification" element={<QualificationDetails />} />
            <Route path="/vendor/dashboard/:tenderId/view-qualification" element={<ViewQualification />} />
            <Route path="/vendor/dashboard/:tenderId/view-emd" element={<ViewEMD />} />
            <Route path="/vendor/dashboard/:tenderId/view-bids" element={<ViewVendorBids />} />
            <Route path="/vendor/dashboard/submit-bid/:tenderId" element={<BidSubmission />} />
            <Route path="/vendor/dashboard/submit-bid/draft/:tenderId" element={<BidSubmission />} />
            <Route path="/vendor/dashboard/submit-rebid/:tenderId" element={<RebidSubmission />} />
            <Route path="/vendor/dashboard/:tenderId/view-query" element={<ViewQueries />} />
            <Route path="/vendor/dashboard/:tenderId/ask-query" element={<AskQuery />} />
          </Route>
        </Route>
        </Routes>
    </div>
  );
}

export default App;
